import Vue from 'vue'
import VueRouter from 'vue-router'

/** 重复路由 */
const H5Login = () => import(/* webpackChunkName: "h5" */ '../views/h5/index.vue')
const ClientLogin = () => import(/* webpackChunkName: "clientLogin" */ '../views/client/login.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/h5sdk',
    component: () => import('../views/index.vue'),
    children: [
      // 半原生登录
      {
        path: '/client/login',
        name: 'client.login',
        component: ClientLogin
      },
      // 半原生v2版本登录(手机号优先)
      {
        path: '/client/v2/login',
        name: 'clientV2.login',
        component: () => import(/* webpackChunkName: "clientLoginV2" */ '../views/client/loginV2.vue')
      },
      // 半原生静默登录
      {
        path: '/client/silent/login',
        name: 'client.silentLogin',
        component: () => import(/* webpackChunkName: "clientSilentLogin" */ '../views/client/loginV2.vue')
      },
      // 盒子登录链接
      {
        path: '/box/login',
        name: 'box.login',
        component: () => import(/* webpackChunkName: "box" */ '../views/client/boxLogin.vue')
      },
      // 半原生支付
      {
        path: '/charge',
        name: 'client.charge',
        component: () => import(/* webpackChunkName: "clientCharge" */ '../views/client/charge.vue')
      },
      // 半原生悬浮窗
      {
        path: '/floatWindow',
        name: 'floatWindow',
        component: () => import(/* webpackChunkName: "floatWindow" */ '../views/float-window/index.vue')
      },
      // h5登录页
      {
        path: '/h5/login',
        name: 'h5.login',
        component: H5Login
      },
      // h5登录页v2版本， 手机号优先
      {
        path: '/h5/v2/login',
        name: 'h5V2.login',
        component: () => import(/* webpackChunkName: "h5V2" */ '../views/h5/loginV2.vue')
      },
      // 彩消h5正式登录页，默认用户名密码登录
      {
        path: '/h5/v2/login-cx',
        name: 'h5V2.logincx',
        component: () => import(/* webpackChunkName: "h5V2" */ '../views/h5/loginCX.vue')
      },
      // 彩消h5登录测试页， 默认用户名密码登录
      {
        path: '/h5/v2/login-test',
        name: 'h5V2.test',
        component: () => import(/* webpackChunkName: "h5V2" */ '../views/h5/loginTest.vue')
      },
      // 彩消h5登录白名单， 默认用户名密码登录
      {
        path: '/h5/v2/login-cx-white',
        name: 'h5V2.white',
        component: () => import(/* webpackChunkName: "h5V2" */ '../views/h5/loginCXWhite.vue')
      },
      // h5静默登录
      {
        path: '/h5/silent/login',
        name: 'h5.silentLogin',
        component: () => import(/* webpackChunkName: "h5SilentLogin" */ '../views/h5/loginV2.vue')
      },
      // v2版本 使用浏览器游玩链接
      {
        path: '/h5/external',
        name: 'h5.external',
        component: () => import(/* webpackChunkName: "h5V2" */ '../views/h5/loginV2.vue')
      },
      // 出错链接
      {
        path: '/h5/fail',
        name: 'h5.fail',
        component: () => import('../views/h5/fail.vue')
      },
      // 在线客服链接
      {
        path: '/h5/manualCustomer',
        name: 'h5.manualCustomer',
        component:  () => import(/* webpackChunkName: "customer" */ '../views/h5/manualCustomer.vue')
      },
      // 提供给纯原生sdk使用的滑块验证界面
      {
        path: '/register-captcha',
        name: "register.captcha",
        component: () => import(/* webpackChunkName: "pure" */ '../views/client/captcha.vue')
      },
      // 3843活动sdk需求 进入游戏后先闪页，之后显示悬浮球点击后是活动列表
      {
        path: '/activity',
        name: "activity",
        component: () => import(/* webpackChunkName: "activity" */ '../views/client/activity/index.vue'),
        children: [
          // 汇总页
          {
            path: 'summary',
            name: 'activity.summary',
            component: () => import(/* webpackChunkName: "activity" */ '../views/client/activity/summary.vue'),
          },
          {
            path: 'flashPage',
            name: 'activity.flashPage',
            component: () => import(/* webpackChunkName: "activity" */ '../views/client/activity/flashPage.vue')
          }
        ]
      },
      // 强更领礼包码页面
      {
        path: '/update-gift',
        name: 'update.gift',
        component: () => import(/* webpackChunkName: "update" */ '../views/client/update/gift.vue')
      },
      // h5三方渠道链接   
      {
        path: '/h5/third',
        name: 'h5.third',
        component: () => import(/* webpackChunkName: "h5Third" */ '../views/h5/thirdLogin.vue')
      },
      // 支付宝红包提现成功页面
      {
        path: '/third/alipay-res',
        name: 'h5.alipay',
        component: () => import(/* webpackChunkName: "third" */ '../views/third/aliPayResult.vue')
      },
      // 提供给盒子使用 云挂机支付页
      {
        path: '/third/cloud-pay',
        name: 'h5.cloudPay',
        component: () => import(/* webpackChunkName: "third" */ '../views/third/cloudPay.vue')
      },
      /** [ 老项目路由兼容 ] */
      {
        path: '/apiYellowLogin/vip-customer',
        name: "client.vip",
        component: () => import(/* webpackChunkName: "pure" */ '../views/client/vipCustomer.vue')
      },
      {
        path: '/yellowlogin',
        name: 'old.login',
        component: H5Login
      },
      {
        path: '/wXin/wornLogin',
        name: 'old.wornLogin',
        component: ClientLogin
      },
      {
        path: '/apiYellowLogin',
        name: 'old.apiYellowLogin',
        component: ClientLogin
      },
      // 跨域缓存账号密码
      { 
        path: '/userlist',
        name: 'client.userList',
        component: () => import(/* webpackChunkName: "clientLogin" */ '../views/client/userList.vue')
      },
      // h5寰宇CPS登录
      {
        path: '/hy/login',
        name: 'hy.login',
        component: H5Login
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: '/h5sdk/',
  routes
})

export default router
